module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"details":"für Medienanfragen wenden Sie sich bitte an","title":"Nehmen Sie Kontakt auf"},"en":{"details":"for media enquiries please contact ","title":"Get in touch"},"it":{"details":"","title":""},"lt":{"details":"Žurnalistams","title":"Susisiekite su mumis"},"pl":{"details":"w sprawie zapytań od mediów prosimy o kontakt ","title":"Kontakt"}}')
  delete Component.options._Ctor
}
